import type * as React from 'react'
import { cn } from '../lib/cn.js'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
  /** Monospace + tabular figures, for IMEIs, order numbers and serials. */
  identifier?: boolean
  /** React 19 passes ref as an ordinary prop — no forwardRef needed. */
  ref?: React.Ref<HTMLInputElement>
}

export function Input({ className, invalid, identifier, ...props }: InputProps) {
  return (
    <input
      className={cn(
        'flex h-8 w-full rounded-md border border-border bg-surface px-2.5 py-1 text-sm',
        'placeholder:text-foreground-subtle',
        'transition-colors focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-surface-sunken',
        identifier && 'font-identifier',
        invalid && 'border-danger focus-visible:border-danger',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...props}
    />
  )
}

export function Textarea({
  className,
  invalid,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }) {
  return (
    <textarea
      className={cn(
        'flex min-h-20 w-full rounded-md border border-border bg-surface px-2.5 py-1.5 text-sm',
        'placeholder:text-foreground-subtle transition-colors focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        invalid && 'border-danger',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...props}
    />
  )
}
